<template>
    <section class="prince shouldFix" v-bind:class="{ open: open }">
      <!-- <div class="block"></div> -->
      
      <div class="main">
        <!-- <div class="bookmark"><img src="../../asset/svg/bookmark/v/support.svg" alt="支持多寶"></div> -->
        <div class="max1000"><a href="javascript:void(0)" class="arrow_back" v-on:click="close()">
            <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
            <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
          <h2 class="artistdescription"><img src="../../asset/svg/prince.svg" alt="200個小王子計畫"></h2>
          <!-- <div class="princevideo">
            <div class="movie">
              <iframe src="https://www.youtube.com/embed/JP-hctsJ6q0" frameborder="0" allowfullscreen></iframe>
            </div> 
          </div>-->
          <div class="txtcontent">
            <h5>邀請您當小王子，一起讓我們的孩子綻放生命花朵</h5>
            <p><b>「如果你愛著一朵盛開在浩瀚星海裡的花，那麼，當你抬頭仰望繁星時，便會感到心滿意足。」<br>"Si tu aimes une fleur qui se trouve dans une étoile, c'est doux, la nuit, de regarder le ciel."</b><br><br>隨著季節風旅行到地球的小王子，當他想念他的B612號小行星，就會仰望滿空繁星的想著：「我的玫瑰花就在星空裡的某個地方。」想著那株獨一無二，專屬於他的玫瑰花，小王子就會很快樂。<br><br>仰望泛自閉兒星空中，「多寶藝術學堂」小行星上，一個個閃爍著獨一無二獨特生命光芒的孩子。<br><br>邀請您來當他們的小王子，每月定期定額捐款，一起和我們「多寶藝術學堂」灌溉施肥，陪伴這些獨特生命狀態的孩子，讓他們一個個獨特的生命，都有機會綻放出一朵朵獨一無二的美麗玫瑰花。</p>
          </div><a href="donate.pdf" class="btn" download>
            <!--downloadicon-->
            <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.42 36.37"><title>download</title><path d="M39.92,28.47h-2a.5.5,0,0,0-.5.5V33.4H3V29a.5.5,0,0,0-.5-.5H.5A.5.5,0,0,0,0,29v5.91a1.49,1.49,0,0,0,1.49,1.49H38.93a1.49,1.49,0,0,0,1.49-1.49V29A.5.5,0,0,0,39.92,28.47Z" /><path d="M20.06,30.41a1.57,1.57,0,0,0,2.55-.86,1.2,1.2,0,0,0,.25-.52c3.06-3.31,6.51-6.17,9.65-9.4,1.34-1.37-.77-3.48-2.1-2.1-2.48,2.55-5.16,4.88-7.69,7.37-.29-7.81,0-15.65-.12-23.46a1.49,1.49,0,0,0-3,0c.12,8.2-.19,16.42.17,24.62-3.3-3.3-6.29-6.9-9.79-10-1.43-1.27-3.54.83-2.1,2.1C12.22,22,15.74,26.57,20.06,30.41Z" /></svg></div><span>下載捐款單</span></a><span class="phonecall">聯絡電話：<a href="tel:0228914606">02-2891-4606</a>傳真電話：<a href="tel:0228914606">02-2891-3024</a></span>
        </div>
        <div class="rose"><img src="../../img/rose.png" alt="rose"></div>
      </div>
    </section>
</template>
<script>
  export default{
   data: function() {
      return{
        princeclose:false
      }
    },
    props: ['open'],
    methods:{
      close:function(){
        console.log('child prince sent');
        this.princeclose=false;
        this.$emit('close');
      }
    }
  }
</script>
<style lang="">
  .prince .txtcontent{
    padding-top:40px;
  }
</style>


// WEBPACK FOOTER //
// Prince.vue?e1abdd3a